import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import * as React from 'react';
import { antGrey, runwayColors } from '../styles/globalStyles';
import { AllFeatureFlagsSortTypes, FeatureFlagsSortType } from '../../types/sorts';
import { displayTextForFeatureFlagsSortType } from '../../helpers/displayHelpers';
import { updateFeatureFlagsSort } from '../../actions/sorts';
import { useDispatch, useSelector } from 'react-redux';
import { selectFeatureFlagsSort } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';
import { AimOutlined, CalendarOutlined, ControlOutlined, SortAscendingOutlined, UserOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';

const FeatureFlagsSortComponent: React.FC = () => {
    const dispatch = useDispatch();

    const onSelectSort = (info) => {
        const sortType = info.key;
        dispatch(updateFeatureFlagsSort({ sortType }));
    };

    const currentlySelectedSort = useSelector((state: RootState) => selectFeatureFlagsSort(state));

    const overlayMenu = () => {
        return (
            <Menu onClick={onSelectSort} activeKey={currentlySelectedSort}>
                {AllFeatureFlagsSortTypes.map((sortType) => (
                    <Menu.Item key={sortType} icon={iconForFeatureFlagsSortType(sortType)}>
                        <div style={{ fontSize: 14, color: antGrey.grey9, fontWeight: 400 }}>
                            {displayTextForFeatureFlagsSortType(sortType)}
                        </div>
                    </Menu.Item>
                ))}
            </Menu>
        );
    };

    return (
        <Dropdown overlay={overlayMenu} trigger={['click']}>
            <Button icon={iconForFeatureFlagsSortType(currentlySelectedSort)}>
                Sort: {displayTextForFeatureFlagsSortType(currentlySelectedSort)}
            </Button>
        </Dropdown>
    );
};

export default FeatureFlagsSortComponent;

const iconForFeatureFlagsSortType: (sortType: FeatureFlagsSortType) => React.ReactNode = (sortType) => {
    const iconStyle: React.CSSProperties = { color: runwayColors.primary };
    switch (sortType) {
        case FeatureFlagsSortType.Highlighted:
            return <AimOutlined style={iconStyle} />;
        case FeatureFlagsSortType.Status:
            return <ControlOutlined style={iconStyle} />;
        case FeatureFlagsSortType.CreatedOn:
            return <CalendarOutlined style={iconStyle} />;
        case FeatureFlagsSortType.Owner:
            return <UserOutlined style={iconStyle} />;
        case FeatureFlagsSortType.Name:
            return <SortAscendingOutlined style={iconStyle} />;
    }
};
